export default "__VITE_ASSET__DMtRQZvb__"